import { UserForm } from "./UserForm";

export const AddUserFormFormTemplate = Object.freeze({
  sections: [
    {
      size: 1 / 2,
      compact: true,
      inputs: [UserForm.title /* UserForm.visible_user */],
    },
    {
      size: 1 / 1,
      compact: true,
      inputs: [UserForm.text, UserForm.text_user],
    },
    {
      size: 1,
      compact: true,
      inputs: [],
    },
  ],
});
